import React from 'react';
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import {
    Button, Form, FormGroup, Label,
    Col,
    Container, Row
} from 'reactstrap';

import SelectListComponent from '../utils/selectList';
import DateSelector from '../utils/dateSelector';
import InfoIcon from 'react-icons/lib/md/info';


const SearchPanel = ({ categories, selectedCat, multiOptions, multiLabelKey, multiValueKey, multiArray, onCatValueChange, onMultiValueChange, onSearch, startDateChange, endDateChange, airlineSelectNotification }) => {
    return (
        <Form onSubmit={e => e.preventDefault()}>
            <Container>
                <Row>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>Start Date</Label>
                            <DateSelector 
                            maxDate={new Date()}
                            todayDate={(new Date()).toString()}
                            name="startDate" onValueChange={startDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>End Date</Label>
                            <DateSelector 
                            maxDate={new Date()}
                            todayDate={(new Date()).toString()}
                            name="endDate" onValueChange={endDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>Categories</Label>
                            <SelectListComponent data={categories} valueKey='value' textField='label' selectValue={selectedCat} onValueChange={onCatValueChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="5">
                        <FormGroup className="mb-4">
                            <Label>Search Box &nbsp;</Label>{airlineSelectNotification && <small style={{color: "#d50000"}}><InfoIcon size="15" />{airlineSelectNotification}</small>}
                            <SelectListComponent data={multiOptions} multiSelectMode={true} selectValue={multiArray} valueKey={multiValueKey} textField={multiLabelKey} onValueChange={onMultiValueChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="1">
                        <label>&nbsp;</label>
                        <Button className="btn-avi-primary" onClick={() => onSearch(1)}>Search</Button>
                    </Col>
                </Row>
            </Container>
            
        </Form>
    )
};

// SearchPanel.propTypes = {
//     categories: PropTypes.array.isRequired,
// }

// function mapStateToProps(state, ownProps) {
//     const { categories } = state;
// }

export default SearchPanel;



// WEBPACK FOOTER //
// ./src/views/search/search-panel.js